import React, { FC, PropsWithChildren } from "react";

type FieldErrorProps = PropsWithChildren;

export const FieldError: FC<FieldErrorProps> = ({ children }) => {
  return (
    <p className="mt-1 whitespace-pre-wrap text-xs text-red-1">{children}</p>
  );
};
